import { webEnv } from "@/config/webEnv";
import type { WebUser } from "@roman/shared/types/WebUser";

// Demo user for development and testing
export const createDemoUser = (): WebUser => ({
  id: "demo-user-123",
  name: "デモユーザー",
  email: "demo@example.com",
  photoUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=demo",
  registeredAt: Date.now(),
  freePoints: "100000",
  redeemablePoints: "338643",
  nanoTon: "0",
  tickets: "10",
  isSMSVerified: true,
  isAgeRegistered: true,
  isSexRegistered: true,
  age: 25,
  sex: "OTHER",
});

// Check if demo mode is enabled (based on API_URL)
export const isDemoMode = (): boolean => {
  return webEnv.API_URL.includes("demo.localhost:3000");
};
